import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import client from "@/lib/api";
import { SupervisorLayout } from "@/layouts/SupervisorLayout";
import { BuildReportView } from "@/pages/CustomerBuildReport";
import { ArrowLeft } from "lucide-react";

export default function BuildReportViewPage() {
  const { orderId } = useParams();
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await client.get(`/admin/build-reports/${orderId}`);
        if (!cancelled) setState({ loading: false, data, error: null });
      } catch (e) {
        if (!cancelled) {
          setState({
            loading: false,
            data: null,
            error: e.response?.data?.detail || "Failed to load report",
          });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [orderId]);

  return (
    <SupervisorLayout hideMobileHeader>
      <div className="px-5 md:px-8 max-w-[1600px]" style={{ paddingTop: 16, paddingBottom: 24 }}>
        <div className="no-print mb-5 flex items-center justify-between gap-3 flex-wrap">
          <Link
            to="/supervisor/build-reports"
            className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-semibold text-white/60 hover:text-white transition-colors"
            data-testid="back-to-build-reports"
          >
            <ArrowLeft size={13} /> Back to Build Reports
          </Link>
          <div className="text-[11px] tracking-[0.22em] uppercase text-white/45 font-semibold">
            Supervisor View · Read-Only
          </div>
        </div>

        {state.loading ? (
          <div className="p-8 text-white/50 text-center" data-testid="build-report-loading">Loading report…</div>
        ) : state.error ? (
          <div className="p-8 text-center" data-testid="build-report-error">
            <div className="text-white text-lg font-semibold mb-2">Report unavailable</div>
            <div className="text-white/50 text-sm">{typeof state.error === "string" ? state.error : "Unknown error"}</div>
          </div>
        ) : (
          <BuildReportView data={state.data} reportPageUrl={null} printable={true} />
        )}
      </div>
    </SupervisorLayout>
  );
}
